import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
}

const EmailSvg: FC<Props> = ({ className, color }) => {
  return (
    <svg
      className={className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M3.5 4H12.5C12.7495 4 12.9848 4.06091 13.1918 4.16868L8.75 7.5C8.30556 7.83333 7.69444 7.83333 7.25 7.5L2.80824 4.16868C3.01523 4.06091 3.2505 4 3.5 4ZM2.00124 5.43843C2.00042 5.45885 2 5.47938 2 5.5V10.5C2 11.3284 2.67157 12 3.5 12H12.5C13.3284 12 14 11.3284 14 10.5V5.5C14 5.47938 13.9996 5.45885 13.9988 5.43843L9.65 8.7C8.67222 9.43333 7.32778 9.43333 6.35 8.7L2.00124 5.43843ZM0.5 5.5C0.5 3.84315 1.84315 2.5 3.5 2.5H12.5C14.1569 2.5 15.5 3.84315 15.5 5.5V10.5C15.5 12.1569 14.1569 13.5 12.5 13.5H3.5C1.84315 13.5 0.5 12.1569 0.5 10.5V5.5Z'
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};

export default EmailSvg;
